import MessageContainer from '../MessageContainer/MessageContainer';
import MessageText from '../MessageText/MessageText';

export default function TextMessage({
  message, myId, withAvatar, isAdmin,
}) {
  return (
    <MessageContainer myId={myId} withAvatar={withAvatar} message={message} isAdmin={isAdmin}>
      <MessageText>{message.text}</MessageText>
    </MessageContainer>
  );
}
